import React, { Fragment, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import sortBy from 'lodash/sortBy';
import TagWithDescriptionPopover from 'legacy-src/utility/TagWithDescriptionPopover';
import {
  BIG_IDEAS,
  COURSE_TRANSFER_SKILLS,
  formatName,
  PROFICIENCIES,
  SKILLS,
  tagsPerSubject,
  TASK_MODELS,
  TOPICS,
  UNITS,
} from 'chameleon-src/utility/utils';
import PracticeSkillsPopOver from 'chameleon-packages/units/components/PracticeSkills';
import './style.scss';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import cn from 'classnames';
import PopOver from 'chameleon/ui-stack/ui/base/popover';

const LeftModalContent = (props) => {
  const {
    masterSubjectId,
    lastModifiedDate,
    itemSharedDate,
    createdBy,
    itemMetadata,
    tags,
    userTimezone,
    createdDate,
  } = props;
  const {
    numberOfQuestions,
    numberOfMcq,
    numberOfFrq,
    numberOfTeacherQuestions,
  } = itemMetadata;

  const {
    units = [],
    topics = [],
    skills = [],
    taskModels = [],
    bigIdeas = [],
    proficiencies = [],
    courseTransferSkills = [],
  } = tags;

  const [tagsToDisplay, setTagsToDisplay] = useState(
    tagsPerSubject(masterSubjectId),
  );

  const formatDate = (date) =>
    dayjs(date).utc(true).tz(userTimezone).format('MM/DD/YY h:mm A');

  const sortedSkills = () => {
    const skillswithSortableLabel = skills.map(
      ({ label, description, ...otherProps }) => ({
        label: label.replace('Skill ', ''),
        name: description,
        ...otherProps,
      }),
    );
    return sortBy(skillswithSortableLabel, ['label']);
  };

  useEffect(() => {
    setTagsToDisplay(tagsPerSubject(masterSubjectId));
  }, [masterSubjectId]);

  const displayTagsTable =
    !!tagsToDisplay.length &&
    Object.values(tags).some((array) => !!array.length);
  const renderIdeas = tagsToDisplay.includes(BIG_IDEAS);
  const unitsOrIdeas = tagsToDisplay.includes(UNITS)
    ? units
    : tagsToDisplay.includes(BIG_IDEAS)
      ? bigIdeas
      : [];
  const topicsOrProficiencies = tagsToDisplay.includes(TOPICS)
    ? topics
    : tagsToDisplay.includes(PROFICIENCIES)
      ? proficiencies
      : [];
  const renderTaskModels = tagsToDisplay.includes(TASK_MODELS);
  const taskModelOrProeficiencies = tagsToDisplay.includes(TASK_MODELS)
    ? taskModels
    : tagsToDisplay.includes(PROFICIENCIES)
      ? proficiencies
      : [];
  const renderMiddleColumn =
    !!topicsOrProficiencies.length || !!taskModelOrProeficiencies.length;
  const renderSkills = tagsToDisplay.includes(SKILLS);
  const renderCourseTransferSkills = tagsToDisplay.includes(
    COURSE_TRANSFER_SKILLS,
  );

  const renderTagsHeaders = () =>
    tagsToDisplay.map((tagName) => (
      <div key={tagName} className="shared_assignment_info__content">
        <h4 data-testid="tags-header">{tagName}</h4>
      </div>
    ));

  const tagsWrapperClassNames = cn('shared_assignment_info__content', {
    'big-ideas-wrapper': !!renderIdeas,
  });
  const taskModelsWrapperClassNames = cn('shared_assignment_info__content', {
    'task-models-wrapper': !!renderTaskModels,
  });
  const skillsWrapperClassNames = cn('shared_assignment_info__content', {
    'skills-wrapper': !!renderSkills,
  });

  return (
    <div className="shared_assignment_left_content">
      <h3>Quiz Details</h3>
      <div className="shared_assignment_info">
        {itemSharedDate && createdBy && (
          <div className="shared_assignment_info__content">
            <h4>Shared By</h4>
            <span data-testid="shared-by">{formatName(createdBy)}</span>
          </div>
        )}
        {createdDate && (
          <div className="shared_assignment_info__content">
            <h4>Date Created</h4>
            <span>{formatDate(createdDate)}</span>
          </div>
        )}
        {itemSharedDate && (
          <div className="shared_assignment_info__content">
            <h4>Date Shared</h4>
            <span data-testid="date-shared">{formatDate(itemSharedDate)}</span>
          </div>
        )}
        {lastModifiedDate && (
          <div className="shared_assignment_info__content">
            <h4>Last Modified</h4>
            <span data-testid="date-created">
              {formatDate(lastModifiedDate)}
            </span>
          </div>
        )}
      </div>
      <div className="shared_assignment_info questions_info_container">
        <div className="shared_assignment_info__content questions_info">
          <h4>MCQs</h4>
        </div>
        <div className="shared_assignment_info__content questions_info">
          <h4>FRQs</h4>
        </div>
        <div className="shared_assignment_info__content questions_info">
          <h4>Total Qs</h4>
        </div>
        <div className="shared_assignment_info__content questions_info">
          <h4 className="grid gap-5 grid-flow-col w-max items-center">
            Teacher-Authored
            <PopOver
              className="cursor-pointer"
              btn=""
              label={<Icon name="info_circle_black" width="16" height="16" />}
              width="200px"
              btnClassName="flex items-start"
            >
              Teacher-authored questions are created by educators. They are
              neither authored nor reviewed by the AP Program.
            </PopOver>
          </h4>
        </div>
      </div>
      <div className="shared_assignment_info">
        <div className="shared_assignment_info__content">{numberOfMcq}</div>
        <div className="shared_assignment_info__content">{numberOfFrq}</div>
        <div className="shared_assignment_info__content">
          {numberOfQuestions}
        </div>
        <div className="shared_assignment_info__content">
          {numberOfTeacherQuestions}
        </div>
      </div>
      {displayTagsTable && (
        <Fragment>
          <div className="shared_assignment_info_skills_topics">
            {renderTagsHeaders()}
          </div>
          <div className="shared_assignment_info_skills_topics">
            <div className={`${tagsWrapperClassNames} mr-9`}>
              <TagWithDescriptionPopover
                tags={sortBy(
                  unitsOrIdeas.map(({ label, ...otherProps }) => ({
                    ...otherProps,
                    title: '',
                    label: Number.isNaN(Number(label)) ? label : Number(label),
                  })),
                  ['label'],
                )}
              />
            </div>
            {renderMiddleColumn && (
              <div
                className={`shared_assignment_info__content tag-wrapper mr-12 ${taskModelsWrapperClassNames}`}
              >
                {!!topicsOrProficiencies.length && (
                  <TagWithDescriptionPopover
                    tags={sortBy(
                      topicsOrProficiencies.map(({ label, ...otherProps }) => ({
                        ...otherProps,
                        title: '',
                        label: Number.isNaN(Number(label))
                          ? label
                          : Number(label),
                      })),
                      ['label'],
                    )}
                  />
                )}
                {!!renderTaskModels &&
                  taskModels.map((taskModel, index) => (
                    <span key={taskModel}>
                      {taskModel.description}
                      {index < taskModels.length - 1 && ', '}
                    </span>
                  ))}
              </div>
            )}
            <div className={skillsWrapperClassNames}>
              {renderSkills && (
                <PracticeSkillsPopOver
                  skillsContainerClassName="justify-start"
                  skills={sortedSkills()}
                />
              )}
              {renderCourseTransferSkills &&
                courseTransferSkills.map((skill, index) => (
                  <span key={skill}>
                    {skill.description}
                    {index < courseTransferSkills.length - 1 && ', '}
                  </span>
                ))}
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default LeftModalContent;
